import { useQuery } from "@tanstack/react-query";
import ticketsService from "services/admin/ticketsService";
import {
    AttentionQueueParams,
    AttentionQueueResponse,
    SlaBreachesParams,
    SlaBreachesResponse,
} from "interfaces/entities/ticketStats";

type Options = { enabled?: boolean; refetchIntervalMs?: number };

// Виджет «Очередь требующая внимания» — обновляется чаще, чем аналитические виджеты,
// потому что это оперативная сводка для менеджера.
export const useAttentionQueue = (
    params: AttentionQueueParams = {},
    options: Options = {}
) => {
    const orgID = localStorage.getItem("orgID") || "";
    const { enabled = true, refetchIntervalMs = 60_000 } = options;

    return useQuery<AttentionQueueResponse>({
        queryKey: ["tickets-attention-queue", orgID, params],
        queryFn: async () => {
            const response = await ticketsService.getAttentionQueue(params);
            return response.data;
        },
        enabled,
        staleTime: 30_000,
        refetchInterval: refetchIntervalMs,
        refetchOnWindowFocus: true,
    });
};

// Виджет «SLA-нарушители» — список активных тикетов с просроченным SLA на решение.
export const useSlaBreaches = (
    params: SlaBreachesParams = {},
    options: Options = {}
) => {
    const orgID = localStorage.getItem("orgID") || "";
    const { enabled = true, refetchIntervalMs = 60_000 } = options;

    return useQuery<SlaBreachesResponse>({
        queryKey: ["tickets-sla-breaches", orgID, params],
        queryFn: async () => {
            const response = await ticketsService.getSlaBreaches(params);
            return response.data;
        },
        enabled,
        staleTime: 30_000,
        refetchInterval: refetchIntervalMs,
        refetchOnWindowFocus: true,
    });
};
